export function resolveFormSubmission(submissions, formKey) {
  if (!Array.isArray(submissions) || !formKey) return null;
  const matches = submissions.filter(
    (submission) =>
      submission?.form_type === formKey || submission?.requirement_id === formKey,
  );
  if (!matches.length) return null;

  const activeMatches = matches.filter((submission) => submission.is_active_attempt !== false);
  const pool = activeMatches.length ? activeMatches : matches;

  return [...pool].sort((left, right) => {
    const leftRank = submissionRank(left);
    const rightRank = submissionRank(right);
    if (leftRank !== rightRank) return rightRank - leftRank;
    const leftDate = left.submitted_at || left.updated_at || left.created_at || '';
    const rightDate = right.submitted_at || right.updated_at || right.created_at || '';
    return String(rightDate).localeCompare(String(leftDate));
  })[0];
}

function submissionRank(submission) {
  const active = submission?.is_active_attempt === false ? 0 : 1;
  const version = Number(submission?.version || 0);
  const attempt = Number(submission?.attempt_number || 0);
  return active * 1000 + version * 10 + attempt;
}